// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divider-T2RUUY{flex-direction:row;align-items:center;width:100%;padding:16px 24px 40px;display:flex}.divider-line-kcdwXM{flex:1;height:1px}.coz-divider-line-style-CPu5vz{background-color:rgba(74,86,111,.2)}.divider-text-fWbjGt{width:-moz-fit-content;text-align:center;word-break:normal;word-wrap:break-word;white-space:pre-wrap;width:fit-content;max-width:280px;padding:0 20px;font-size:12px;font-style:normal;font-weight:400;line-height:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": `divider-T2RUUY`,
	"divider-line": `divider-line-kcdwXM`,
	"dividerLine": `divider-line-kcdwXM`,
	"coz-divider-line-style": `coz-divider-line-style-CPu5vz`,
	"cozDividerLineStyle": `coz-divider-line-style-CPu5vz`,
	"divider-text": `divider-text-fWbjGt`,
	"dividerText": `divider-text-fWbjGt`
};
export default ___CSS_LOADER_EXPORT___;
